import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Pagination, PaginationParams } from '../model/pagination';

export abstract class BaseApiService<T, ID = number | string> {
  protected abstract endpoint: string;

  constructor(protected http: HttpClient) {}

  protected buildParams(params?: PaginationParams): HttpParams {
    let httpParams = new HttpParams();
    if (params) {
      if (params.search) httpParams = httpParams.set('search', params.search);
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString());
      if (params.size) httpParams = httpParams.set('size', params.size.toString());
      if (params.sort) {
        let sortValue = params.sort.includes(':') ? params.sort.replace(':', ',') : params.sort;
        httpParams = httpParams.set('sort', sortValue);
      }
      if (params.dateFrom) httpParams = httpParams.set('dateFrom', params.dateFrom);
      if (params.dateTo) httpParams = httpParams.set('dateTo', params.dateTo);
      if (params.status) {
        const statuses = Array.isArray(params.status) ? params.status : [params.status];
        statuses.forEach(s => httpParams = httpParams.append('status', s));
      }
    }
    return httpParams;
  }

  getList(params?: PaginationParams): Observable<Pagination<T>> {
    const url = `${environment.apiUrl}${this.endpoint}`;
    const httpParams = this.buildParams(params);
    return this.http.get<Pagination<T>>(url, { params: httpParams });
  }

  getById(id: ID): Observable<T> {
    return this.http.get<T>(`${environment.apiUrl}${this.endpoint}/${id}`);
  }

  save(data: T): Observable<T> {
    return this.http.post<T>(`${environment.apiUrl}${this.endpoint}`, data);
  }

  delete(id: ID): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}${this.endpoint}/${id}`);
  }
}
